/** Compare validated ISO/RFC3339 clocks without discarding server micro/nanoseconds. */
export function compareIsoTime(a: string, b: string): number {
  const milliseconds = Date.parse(a) - Date.parse(b);
  if (milliseconds) return milliseconds;
  const fraction = (value: string) =>
    (/\.(\d+)(?:Z|[+-]\d{2}:\d{2})$/.exec(value)?.[1] ?? '').padEnd(9, '0').slice(3);
  return fraction(a).localeCompare(fraction(b));
}
